import React, { useState,useEffect } from 'react'
import './Chat.css'
import { Avatar, IconButton } from '@material-ui/core'
import { AttachFile, MoreVert, SearchOutlined } from '@material-ui/icons'
import InsertEmoticonOutlinedIcon from '@material-ui/icons/InsertEmoticonOutlined'
import MicOutlinedIcon from '@material-ui/icons/MicOutlined';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import {useParams} from 'react-router-dom'
import db from './firebase'
import { useStateValue } from './StateProvider';
import firebase from 'firebase'

function Chat() {
   const[{user},dispatch] = useStateValue();
   
   
   const[input,setInput] = useState('');
   const[messages,setMessages] = useState([]);
   const {roomId} = useParams();  //ending part of url in routing
    const[roomName,setRoomName] = useState('');
    const sendMessage = (e)=>{
        e.preventDefault();
        console.log(input);
        db.collection('rooms').doc(roomId).collection("messages").add({
          message: input,
          name: user.displayName,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })
        setInput('')
    }

    useEffect(()=>{
        if(roomId){
          db.collection("rooms").doc(roomId).onSnapshot(snapshot => (setRoomName(snapshot.data().name)))
          db.collection("rooms").doc(roomId).collection("messages").orderBy("timestamp","asc")
          .onSnapshot(snapshot =>(
            setMessages(snapshot.docs.map(doc => doc.data()))
          ))
        }
    },[roomId]);

    const[value,setValue] = useState("");  //for changing avatars

    useEffect(()=>{
       setValue(Math.floor(Math.random()*5000));
       console.log(value);
    },[roomId])


    //chat header
    //main chat section
    //input text section
  return (
    <div className='chat'>
        <div className='mainchat_header'>
            <Avatar src={`https://avatars.dicebear.com/api/human/${value}.svg`}/>
            <div className='person_info'>
                <h3>{roomName}</h3>
                <p>Last seen Today at 18:00</p>
            </div>
            <div className='header_icons'>
              <IconButton>
                <SearchOutlined />
              </IconButton>
              <IconButton>
                <AttachFile />
              </IconButton>
              <IconButton>
                 <MoreVert/>
              </IconButton>
            </div>

        </div>
         {messages.map(message =>(
            <div className='chat_body'>
            <p className={`chat_message ${message.name === user.displayName && "chat_reciever"}`}> 
            <span className='chat_name'>{message.name}</span >
            {message.message}
            <span className='chat_timestamp'> 
             {new Date(message.timestamp?.toDate()).toUTCString()}
            </span> </p>
           
          </div>
         ))}
        

        <div className='chat_footer'>
         <InsertEmoticonOutlinedIcon />
         <form>
         <input type="text" 
          placeholder='Type a message....'
          value = {input}
           onChange = {(e) => setInput(e.target.value)}
           />
          <button type='submit' onClick={sendMessage}>Send message</button>
         </form>
          <MicOutlinedIcon />
        </div>


    </div>
  )
}

export default Chat